import React, { useState, useEffect } from "react";
import Table from "../table";
import AddEventModal from "./AddEventModal";
import { formatDate } from "../../utils/helper";
import styles from "./Events.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-hot-toast";

import { deletePatientReadingEvent } from '../../services/patient/details'

const Events = ({
  isModalOpen,
  onOpenModal,
  onCloseModal,
  events = [],
  setEvents,
  readingType
}) => {

  const [isDeleting, setIsDeleting] = useState(false);
  
  const handleDeleteEvent = async (eventId) => {
    setIsDeleting(true);
    try {
      await deletePatientReadingEvent(eventId);
      if (setEvents) setEvents(); 
      toast.success(`Event deleted successfully`);
    } catch (error) {
      toast.error("Failed to delete event:", error);
    } finally {
        setIsDeleting(false);
    }
  };

  const columns = [
    {
      key: "description",
      label: "Description",
      alignLeft: true,
    },
    {
      key: "date", 
      label: "Date",
      render: (row) => formatDate(row.event_date), 
    },
    {
      key: "created_by",
      label: "Created By",
      alignLeft: true,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <button
          className={styles.action_btn}
          onClick={() => handleDeleteEvent(row.id)}
          title="Delete"
          disabled={isDeleting}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      ),
      alignLeft: true,
    },
  ];

  return (
    <div className={styles.eventsContainer}>
      <Table columns={columns} data={events} height={420} />
      
      <AddEventModal
        isOpen={isModalOpen}
        onClose={onCloseModal}
        onSubmitSuccess={() => {
          // Trigger refetch in parent
          if (setEvents) setEvents();
        }}
        readingType={readingType}
      />
    </div>
  );
};

export default Events;